var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCaraFeliz(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "82px",
    height: "82px",
    viewBox: "0 0 82 82",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icono-1@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "11.76%",
    y1: "81.86%",
    x2: "83.72%",
    y2: "21.9%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6D436",
    offset: "3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8C536",
    offset: "13%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE9D35",
    offset: "34%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D75D33",
    offset: "62%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF2232",
    offset: "86%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-31.4678449%",
    y1: "85.1202035%",
    x2: "145.139912%",
    y2: "-5.14157973%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6D436",
    offset: "3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8C536",
    offset: "13%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE9D35",
    offset: "34%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D75D33",
    offset: "62%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF2232",
    offset: "86%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-331.432749%",
    y1: "367.909357%",
    x2: "194.517544%",
    y2: "-70.3947368%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6D436",
    offset: "3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8C536",
    offset: "13%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE9D35",
    offset: "34%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D75D33",
    offset: "62%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF2232",
    offset: "86%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-230.701754%",
    y1: "283.918129%",
    x2: "295.248538%",
    y2: "-154.385965%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6D436",
    offset: "3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8C536",
    offset: "13%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE9D35",
    offset: "34%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D75D33",
    offset: "62%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF2232",
    offset: "86%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols-DIC",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "elementos-/-icono-1",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icono-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41,82 C18.3563253,82 0,63.6436747 0,41 C0,18.3563253 18.3563253,0 41,0 C63.6436747,0 82,18.3563253 82,41 C81.9728898,63.6324358 63.6324358,81.9728898 41,82 Z M41,5.6744 C21.4902098,5.6744 5.6744,21.4902098 5.6744,41 C5.6744,60.5097902 21.4902098,76.3256 41,76.3256 C60.5097902,76.3256 76.3256,60.5097902 76.3256,41 C76.3030065,21.499576 60.500424,5.69699349 41,5.6744 Z",
    id: "Shape",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5324006,63 C31.4086675,62.9909718 24.0133932,55.5111938 24,46.2786885 C24,44.4679189 25.4506238,43 27.2400589,43 C29.029494,43 30.4801178,44.4679189 30.4801178,46.2786885 C30.4801178,51.8784937 34.9661719,56.4180328 40.5,56.4180328 C46.0338281,56.4180328 50.5198822,51.8784937 50.5198822,46.2786885 C50.5198822,44.4679189 51.970506,43 53.7599411,43 C55.5493762,43 57,44.4679189 57,46.2786885 C56.9867484,55.485684 49.6308196,62.9549437 40.5324006,63 L40.5324006,63 Z",
    id: "Path",
    fill: "url(#linearGradient-2)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "url(#linearGradient-3)",
    cx: 50.5,
    cy: 29.5,
    r: 5.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "url(#linearGradient-4)",
    cx: 31.5,
    cy: 29.5,
    r: 5.5
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaraFeliz);
export default __webpack_public_path__ + "static/media/cara-feliz.035cfb7813484d8fa19fa046e185de3e.svg";
export { ForwardRef as ReactComponent };